import { useEffect } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from 'react-router';

import useThemeHotkey from '@cartwhl/common/hooks/useThemeHotkey';
import { setNavigate } from '@cartwhl/common/navigation';
import ActivateEarlyTrialModalHost from '@cartwhl/ui/modals/ActivateEarlyTrialModalHost';
import PurchaseCreditsModalHost from '@cartwhl/ui/modals/PurchaseCreditsModalHost';

import { applets } from './applets';
import AppletGuard from './components/AppletGuard';
import Dashboard from './components/Dashboard';
import Notices from './components/Notices';
import PageLayout from './components/PageLayout';
import { ModalManager } from './modals';

function AppContent() {
  const navigate = useNavigate();
  useThemeHotkey();

  // Set the global navigate function for the app.
  useEffect(() => setNavigate(navigate), [navigate]);
  return (
    <>
      <Notices />
      <ModalManager />
      <PurchaseCreditsModalHost />
      <ActivateEarlyTrialModalHost />
      <Routes>
        <Route element={<PageLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/all" element={<Navigate to="/" replace />} />
          <Route path="/:tab" element={<Dashboard />} />
        </Route>
        {applets.flatMap((applet) =>
          applet.paths.map((path) => (
            <Route
              key={`${applet.id}-${path}`}
              path={path}
              element={<AppletGuard applet={applet} />}
            />
          )),
        )}
      </Routes>
    </>
  );
}

export default function AppWithRouter() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
